//import Swiper from 'swiper/js/swiper'
import Swiper from 'swiper/bundle';

function businessesCarousel() {
  function setSlider() {
    const slider = new Swiper('.js-business-cards-slider', {
      loop: false,
      autoplay: false,
      slidesPerView: 1.05,
      roundLengths: true,
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: '.c-business-slider-next',
        prevEl: '.c-business-slider-prev',
      },
      pagination: {
        el: '.c-business-pagination',
        clickable: true,
      },
      breakpoints: {
        // when window width is >= 320px
        500: {
          slidesPerView: 2.05,
        },
        // when window width is >= 480px
        850: {
          slidesPerView: 3.05,
        },
        // when window width is >= 640px
        1200: {
          slidesPerView: 4.05,
        },
      },
    })
  }

  const isPresent = document.getElementsByClassName('c-business-cards')
  if (isPresent.length > 0) {
    setSlider()
  }
}

export { businessesCarousel }

function feedbackCarousel() {
  function setSlider() {
    const slider = new Swiper('.js-feedback-slider', {
      // loop: true,
      autoplay: false,
      // spaceBetween: 20,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      slidesPerView: 1,
      roundLengths: true,
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: '.c-feedback-slider-next',
        prevEl: '.c-feedback-slider-prev',
      },
      pagination: {
        el: '.c-feedback-pagination',
        clickable: true,
      },
    })
  }

  const isPresent = document.getElementsByClassName('c-feedback-block')
  if (isPresent.length > 0) {
    setSlider()
  }
}

export { feedbackCarousel }

function galleryCarousel() {
  function setSlider() {
    const slider = new Swiper('.js-gallery-slider', {
      loop: false,
      autoplay: false,
      slidesPerView: 1,
      // centeredSlides: true,
      slidesPerGroup: 1,
      roundLengths: true,
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: '.c-gallery-slider-next',
        prevEl: '.c-gallery-slider-prev',
      },
      pagination: {
        el: '.c-gallery-pagination',
        clickable: true,
      },
      breakpoints: {
        // when window width is >= 320px
        600: {
          slidesPerGroup: 2,
          slidesPerView: 2,
          spaceBetween: 20,
        },
        // when window width is >= 480px
        850: {
          slidesPerGroup: 2,
          slidesPerView: 'auto',
          spaceBetween: 20,
        },
        // when window width is >= 640px
        1200: {
          slidesPerView: 'auto',
          slidesPerGroup: 2,
          spaceBetween: 20,
        },
      },
    })
  }

  const isPresent = document.getElementsByClassName('c-gallery-slider-wrap')
  if (isPresent.length > 0) {
    setSlider()
  }
}

export { galleryCarousel }
